import { render, staticRenderFns } from "./VIewPatientLabRequestDialog.vue?vue&type=template&id=6321db1a&scoped=true"
import script from "./VIewPatientLabRequestDialog.vue?vue&type=script&lang=js"
export * from "./VIewPatientLabRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6321db1a",
  null
  
)

export default component.exports